module.exports = __webpack_public_path__ + "img/mBean.226da5d9.svg";